import { CurrentStatementComponent } from '../current-statement/current-statement.component';
import { PaymentHistoryComponent } from '../payment-history/payment-history.component';
import { PaymentReceiptsComponent } from '../payment-receipts/payment-receipts.component';
import { PaymentMethodComponent } from '../payment-method/payment-method.component';
import { PaymentScheduleComponent } from '../payment-schedule/payment-schedule.component';
import { BillingCardConfig } from './billing-card-config.model';

export const BILLING_CARD_CONFIGS: BillingCardConfig[] = [
  {
    component: CurrentStatementComponent,
    name: 'current-statement',
    menuLabel: 'Statement',
    inputs: {
      dcBillingFailed: 'dcBillingFailed',
    },
    outputs: {},
  },
  {
    component: PaymentHistoryComponent,
    name: 'payment-history',
    menuLabel: 'History',
    inputs: {
      dcBillingFailed: 'dcBillingFailed',
    },
    outputs: {},
  },
  {
    component: PaymentReceiptsComponent,
    name: 'payment-receipts',
    menuLabel: 'Receipts',
    inputs: {
      dmsFailed: 'dmsFailed',
    },
    outputs: {},
  },
  {
    component: PaymentScheduleComponent,
    name: 'payment-schedule',
    menuLabel: 'Schedule',
    inputs: {
      dcBillingFailed: 'dcBillingFailed',
    },
    outputs: {},
  },
  {
    component: PaymentMethodComponent,
    name: 'payment-method',
    menuLabel: 'Pay Method',
    inputs: {
      dcBillingFailed: 'dcBillingFailed',
    },
    outputs: {
      addPaymentMethodClicked: 'onAddPaymentMethodClicked',
    },
  },
];
